// cw-rolloff/client/src/store/modules/locations.js
import { CUSTOMER_FAMILY_QUERY } from '@/graphql/constants';
import apolloClient from '@/graphql'; // The Apollo Client instance

const locations = {
  namespaced: true,
  state: {
    customerFamily: [],
    selectedCustomerId: localStorage.getItem('selectedCustomerId') || null,
    loading: false,
    error: null,
  },

  getters: {
    currentLocation: state => {
      if (!state.selectedCustomerId || !state.customerFamily.length)
        return null;
      return (
        state.customerFamily.find(
          c => c.customerId === state.selectedCustomerId
        ) || null
      );
    },

    hasMultipleLocations: state => state.customerFamily.length > 1,

    locationName: (state, getters) => {
      const location = getters.currentLocation;
      if (!location) return '';
      return (
        location.serviceArea ||
        (location.address && location.address.city) ||
        location.name
      );
    },
  },

  mutations: {
    setCustomerFamily(state, customerFamily) {
      state.customerFamily = customerFamily;
    },

    setSelectedCustomerId(state, customerId) {
      state.selectedCustomerId = customerId;

      // Save to localStorage for persistence
      if (customerId) {
        localStorage.setItem('selectedCustomerId', customerId);
      }
    },

    setLoading(state, loading) {
      state.loading = loading;
    },

    setError(state, error) {
      state.error = error;
    },

    resetLocations(state) {
      state.customerFamily = [];
      state.selectedCustomerId = null;
      localStorage.removeItem('selectedCustomerId');
    },
  },

  actions: {
    async fetchCustomerFamily({ commit }) {
      commit('setLoading', true);
      commit('setError', null);

      try {
        const result = await apolloClient.defaultClient.query({
          query: CUSTOMER_FAMILY_QUERY,
          fetchPolicy: 'network-only', // Don't use cache for this
        });

        if (result.data && result.data.customerFamily) {
          commit('setCustomerFamily', result.data.customerFamily);

          // Set initial location if not set already or validate existing selection
          if (result.data.customerFamily.length > 0) {
            const currentId = this.state.locations.selectedCustomerId;

            // Check if current selection is valid
            const currentIsValid =
              currentId &&
              result.data.customerFamily.some(c => c.customerId === currentId);

            if (currentIsValid) {
              // Current selection is valid, keep it
              return;
            }

            // Try to restore from localStorage
            const savedId = localStorage.getItem('selectedCustomerId');
            const validSavedId =
              savedId &&
              result.data.customerFamily.some(c => c.customerId === savedId);

            if (validSavedId) {
              commit('setSelectedCustomerId', savedId);
            } else {
              // Fall back to first location
              commit(
                'setSelectedCustomerId',
                result.data.customerFamily[0].customerId
              );
            }
          }
        }
      } catch (error) {
        console.error('Error fetching customer family:', error);
        commit('setError', error);
      } finally {
        commit('setLoading', false);
      }
    },

    selectLocation({ commit }, customerId) {
      commit('setSelectedCustomerId', customerId);
    },

    resetLocations({ commit }) {
      commit('resetLocations');
    },
  },
};

export default locations;
